import axios from '@/lib/axios'
import { globalError } from '@/lib/utils'

export function getUserInfo(id) {
  return axios()
    .get('/api/admin/view_user', { params: { id: id } })
    .catch(err => globalError(err))
}

export function updateUserInfo(info) {
  return axios().post('/api/admin/update_user_profile', info)
}

export function updateUserAgency(id, agencies) {
  return axios()
    .post('/api/admin/update_user_agency', {
      id,
      agencies,
    })
    .catch(err => globalError(err))
}

export function updateUserState(id, states) {
  return axios()
    .post('/api/admin/update_user_state', {
      id,
      states,
    })
    .catch(err => globalError(err))
}
export function updateUserStatus(id, userLevel, sworn, status, iceAgent) {
  return axios()
    .post('/api/admin/update_user_status', {
      id,
      userLevel,
      sworn,
      status,
      iceAgent,
    })
    .catch(err => globalError(err))
}
